import { Image, LinkButton, UIHeading2 } from '@cian/ui-kit';

import { FC } from 'react';

import styles from './SpecialProjectBuilder.css';

type TSpecialProjectBuilderProps = {
  allOffersUrl: string;
  cardUrl: string;
  logoUrl?: string;
  title: string;
  onLogoClick: () => void;
  onButtonClick: () => void;
};

export const SpecialProjectBuilder: FC<TSpecialProjectBuilderProps> = ({
  allOffersUrl,
  cardUrl,
  logoUrl,
  title,
  onLogoClick,
  onButtonClick,
}) => {
  return (
    <div className={styles['container']}>
      <a
        className={styles['logo']}
        data-testid="SpecialProjectBuilderLogo"
        href={cardUrl}
        rel="noopener noreferrer"
        target="_blank"
        onClick={onLogoClick}
      >
        {logoUrl && <Image preloader objectFit="contain" src={logoUrl} theme="light" />}
      </a>
      <div className={styles['title']} data-testid="SpecialProjectBuilderTitle">
        <UIHeading2 color="text-primary-default">{title}</UIHeading2>
      </div>
      <div className={styles['control']}>
        <LinkButton
          data-testid="SpecialProjectBuilderButton"
          fullWidth={false}
          href={allOffersUrl}
          size="XS"
          target="_blank"
          theme="fill_secondary"
          onClick={onButtonClick}
        >
          Смотреть все предложения
        </LinkButton>
      </div>
    </div>
  );
};
